import FullCalendar from "@fullcalendar/react";
import i18next from "i18next";
import {useTranslation} from "react-i18next";
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction';
import { BaseCard } from "../../Components/Cards/BaseCard";
import timeGridPlugin from '@fullcalendar/timegrid'
import DatePicker, { registerLocale } from "react-datepicker";
import nl from 'date-fns/locale/nl';
import fr from 'date-fns/locale/fr';
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faCalendar, faList } from "@fortawesome/free-solid-svg-icons";
import { useBoundStore } from "../../Store/store";
import dayjs from "dayjs";
import * as React from "react";
import { CreateShiftDialog } from "../../Components/Dialogs/Shifts/CreateShiftDialog";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UpdateShiftDialog } from "../../Components/Dialogs/Shifts/UpdateShiftDialog";
import nlLocale from '@fullcalendar/core/locales/nl';
import frLocale from '@fullcalendar/core/locales/fr';
import { SelectInput } from "../../Components/Form/SelectInput";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ChangeDatesForShiftDialog } from "../../Components/Dialogs/Shifts/ChangeDatesForShiftDialog";
import { TanStackTable } from "../../Components/Tables/TanStackTable";
import { createColumnHelper } from "@tanstack/react-table";
import { truncateString } from "../../Utils/StringHelper";
import { DateTimePickerInput } from "../../Components/Form/DateTimePickerInput";
import { Link } from "react-router-dom";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

export const Shifts = () => {
    const {t, i18n} = useTranslation();
    const currentLang = i18n.language || 'nl';
    const calendarRef = useRef(null);
    const datePickerRef = useRef(null);
    const navigate = useNavigate();

    registerLocale('nl', nl);
    registerLocale('fr', fr);

    const shifts = useBoundStore((state) => state.shifts);
    const shiftsPaginationMeta = useBoundStore((state) => state.shiftsPaginationMeta);
    const getMyShifts = useBoundStore((state) => state.getMyShifts);
    const user = useBoundStore((state) => state.user);
    const getMyBranchesNotPaginated = useBoundStore(state => state.getMyBranchesNotPaginated);
    const branchesNotPaginated = useBoundStore(state => state.branchesNotPaginated);

    const [searchParams] = useSearchParams();
    const dateFromMail = searchParams.get("date")

    const [date, setDate] = useState(dayjs());
    const [open, setOpen] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [openEditTimes, setOpenEditTimes] = useState(false);
    const [shiftObjectToEdit, setShiftObjectToEdit] = useState(null);
    const [shiftObjectToEditTimes, setShiftObjectToEditTimes] = useState(null);
    const [visibleDate, setVisibleDate] = useState(dayjs());
    const [calendarLoading, setCalendarLoading] = useState(false);
    const [viewMode, setViewMode] = useState(() => {
        if (typeof window !== 'undefined') {
            const storedViewMode = localStorage.getItem('ccp_shifts_view_mode');
            return storedViewMode || 'calendar';
        }
        return 'calendar';
    });
    const [currentPage, setCurrentPage] = useState(0);

    const [isLocalStorageReady, setIsLocalStorageReady] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const storedUserId = localStorage.getItem('ccp_shifts_user_id');

            if (!user?.id) {
                if (storedUserId) {
                    localStorage.removeItem('ccp_shifts_user_id');
                    localStorage.removeItem('ccp_shifts_branch_id');
                    localStorage.removeItem('ccp_shifts_status');
                    localStorage.removeItem('ccp_shifts_start_time');
                    localStorage.removeItem('ccp_shifts_end_time');
                    localStorage.removeItem('ccp_shifts_view_mode');
                }
                setIsLocalStorageReady(false);
                setIsInitialized(false);
            } else {
                if (storedUserId && storedUserId !== String(user.id)) {
                    localStorage.removeItem('ccp_shifts_branch_id');
                    localStorage.removeItem('ccp_shifts_status');
                    localStorage.removeItem('ccp_shifts_start_time');
                    localStorage.removeItem('ccp_shifts_end_time');
                    localStorage.removeItem('ccp_shifts_view_mode');
                    setIsInitialized(false);
                }
                localStorage.setItem('ccp_shifts_user_id', String(user.id));
                setIsLocalStorageReady(true);
            }
        }
    }, [user?.id]);


    const schema = yup.object({
        branch_id: yup.string().nullable(),
        start_time: yup.date().nullable(),
        end_time: yup.date().nullable(),
        status: yup.string().nullable(),
    }).required()

    const {
        formState: { errors },
        getValues,
        setValue,
        control,
        watch,
        register
    } = useForm({
        resolver: yupResolver(schema),
        reValidateMode: 'onBlur',
        mode: 'onChange',
        defaultValues: {
            branch_id: null,
            start_time: dayjs().startOf('day').toDate(),
            end_time: null,
            status: null,
        }
    });

    const branchId = watch('branch_id');
    const startTime = watch('start_time');
    const endTime = watch('end_time');
    const status = watch('status');

    useEffect(() => {
        if (typeof window !== 'undefined' && user?.id && isLocalStorageReady && branchesNotPaginated.length > 0 && !isInitialized) {
            const storedBranchId = localStorage.getItem('ccp_shifts_branch_id');
            const storedStatus = localStorage.getItem('ccp_shifts_status');
            const storedStartTime = localStorage.getItem('ccp_shifts_start_time');
            const storedEndTime = localStorage.getItem('ccp_shifts_end_time');

            if (storedBranchId) {
                const matchingBranch = branchesNotPaginated.find(b => String(b.id) === storedBranchId);
                if (matchingBranch) {
                    setValue('branch_id', matchingBranch.id);
                } else {
                    localStorage.removeItem('ccp_shifts_branch_id');
                }
            }

            if (storedStatus) setValue('status', storedStatus);
            if (storedStartTime) setValue('start_time', new Date(storedStartTime));
            if (storedEndTime) setValue('end_time', new Date(storedEndTime));

            setIsInitialized(true);
        } else if (user?.id && isLocalStorageReady && branchesNotPaginated.length > 0 && !isInitialized) {
            setIsInitialized(true);
        }
    }, [user?.id, isLocalStorageReady, branchesNotPaginated, setValue, isInitialized]);

    useEffect(() => {
        if (viewMode) {
            localStorage.setItem('ccp_shifts_view_mode', viewMode);
        }
    }, [viewMode]);

    useEffect(() => {
        if (!isInitialized) return;
        if (branchId !== undefined) {
            if (branchId === null || branchId === '') {
                localStorage.removeItem('ccp_shifts_branch_id');
            } else {
                localStorage.setItem('ccp_shifts_branch_id', branchId);
            }
        }
    }, [branchId, isInitialized]);

    useEffect(() => {
        if (!isInitialized) return;
        if (status !== undefined) {
            if (status === null || status === '') {
                localStorage.removeItem('ccp_shifts_status');
            } else {
                localStorage.setItem('ccp_shifts_status', status);
            }
        }
    }, [status, isInitialized]);

    useEffect(() => {
        if (!isInitialized) return;
        if (startTime !== undefined) {
            if (startTime === null) {
                localStorage.removeItem('ccp_shifts_start_time');
            } else {
                localStorage.setItem('ccp_shifts_start_time', startTime.toISOString());
            }
        }
    }, [startTime, isInitialized]);

    useEffect(() => {
        if (!isInitialized) return;
        if (endTime !== undefined) {
            if (endTime === null) {
                localStorage.removeItem('ccp_shifts_end_time');
            } else {
                localStorage.setItem('ccp_shifts_end_time', endTime.toISOString());
            }
        }
    }, [endTime, isInitialized]);

    useEffect(() => {
        if (dateFromMail) {
            const parsedDate = dayjs.unix(Number(dateFromMail));
            setDate(parsedDate);
            setVisibleDate(parsedDate);

            if (calendarRef.current?.getApi) {
                calendarRef.current.getApi()?.gotoDate(parsedDate.toDate());
            }
        }
    }, [calendarRef, dateFromMail]);

    useEffect(() => {
        if (!isInitialized) return;
        setCurrentPage(0);
    }, [branchId, status, startTime, endTime]);

    useEffect(() => {
        if (!isInitialized) return;

        setCalendarLoading(true);
        if (viewMode === 'calendar') {
            const monthStart = visibleDate.startOf('month').unix();
            const monthEnd = visibleDate.endOf('month').unix();
            getMyShifts(null, null, monthStart, monthEnd, [], null, branchId, null, status)
                .finally(() => setCalendarLoading(false));
        } else {
            const startTimeUnix = startTime ? dayjs(startTime).unix() : null;
            const endTimeUnix = endTime ? dayjs(endTime).unix() : null;
            getMyShifts(null, null, startTimeUnix, endTimeUnix, [], null, branchId, currentPage + 1, status)
                .finally(() => setCalendarLoading(false));
        }
    }, [isInitialized, getMyShifts, visibleDate, branchId, viewMode, startTime, endTime, currentPage, status]);

    const handleDateClick = (arg) => {
        const clicked = dayjs(arg.date);
        setVisibleDate(clicked);
        setCalendarLoading(true);
        const monthStart = clicked.startOf('month').unix();
        const monthEnd = clicked.endOf('month').unix();
        getMyShifts(null, null, monthStart, monthEnd, [], null, branchId, null, status)
            .finally(() => setCalendarLoading(false));
    }

    useEffect(() => {
        if (!isInitialized) return;

        const interval = setInterval(() => {
            if (viewMode === 'calendar') {
                const monthStart = visibleDate.startOf('month').unix();
                const monthEnd = visibleDate.endOf('month').unix();
                getMyShifts(null, null, monthStart, monthEnd, [], null, branchId, null, status);
            }
        }, 60 * 1000);
        return () => clearInterval(interval);
    }, [isInitialized, viewMode, visibleDate, branchId, status, getMyShifts]);

    useEffect(() => {
        getMyBranchesNotPaginated();
    }, [getMyBranchesNotPaginated]);

    const statuutAbbr = {freelance: 'F', interim: 'I', student: 'S', flexi_job: 'X'};
    const statutenBadges = (allowed) => {
        const list = allowed?.length ? allowed : ['freelance'];
        return list.map(s => statuutAbbr[s] ?? s);
    };
    const isMultiStatuut = (allowed) => (allowed?.length ?? 0) > 1;

    const events = shifts.map((shift) => {
        let phaseColor = 'grey';

        let title = '';
        if (shift?.freelancer) {
            title = `${shift?.freelancer?.first_name} ${shift?.freelancer?.last_name} (${shift?.freelancer?.tel})\r\n${shift.branch.company_name}`
        }

        const badges = statutenBadges(shift.allowed_statuten);
        const multi = isMultiStatuut(shift.allowed_statuten);
        const multiClass = multi ? 'multi-statuut-event' : '';

        const textForApplicationPossibility = shift.shift_applications_possibility === 'both' ? t('shifts.vpk_or_zk') : shift.shift_applications_possibility === 'only_verpleegkundige' ? t('shifts.vpk_abbr') : t('shifts.zk_abbr');
        if (!shift.has_contract && shift.applications_count === 0) {
            const unpublishedClass = shift?.is_published != 1 ? 'striped-red-grey' : '';
            return {
                id: shift.id,
                title: `${t('shifts.open_no_candidacy')} (${textForApplicationPossibility})\r\n${shift.branch.company_name}`,
                start: shift.start_time,
                end: shift.end_time,
                backgroundColor: 'grey',
                borderColor: 'grey',
                className: `${unpublishedClass} ${multiClass}`.trim(),
                extendedProps: { badges, multi },
            }
        }

        if (shift.has_contract) {
            phaseColor = 'green';
        }

        if ((shift?.freelancer?.id === null || shift?.freelancer?.id === undefined) && shift.applications_count > 0) {
            phaseColor = 'orange';
            title = `${t('shifts.candidates_available_no_confirmation')} (${textForApplicationPossibility})\r\n${shift.branch.company_name}`
        }

        return {
            id: shift.id,
            title: title,
            start: shift.start_time,
            end: shift.end_time,
            backgroundColor: phaseColor,
            borderColor: phaseColor,
            className: multiClass,
            extendedProps: { badges, multi },
        }
    });

    const columnHelper = createColumnHelper();
    const columns = [
        columnHelper.accessor('start_time', {
            header: t('general.fields.start'),
            cell: props => dayjs(props.cell.getValue()).format('DD/MM/YYYY HH:mm'),
        }),
        columnHelper.accessor('end_time', {
            header: t('general.fields.end'),
            cell: props => dayjs(props.cell.getValue()).format('DD/MM/YYYY HH:mm'),
        }),
        columnHelper.accessor('is_published', {
            header: t('tables.published'),
            enableSorting: false,
            cell: props => props.cell.getValue() ? t('general.labels.yes') : t('general.labels.no'),
        }),
        columnHelper.accessor('branch', {
            header: t('tables.branch'),
            enableSorting: false,
            cell: props => truncateString(`${props.cell.getValue()?.company_name ?? '-'}`),
        }),
        columnHelper.accessor('freelancer', {
            header: i18next.t('shifts_module.column_freelancer'),
            enableSorting: false,
            cell: props => {
                const freelancer = props.cell.getValue();
                if (freelancer) {
                    return truncateString(`${freelancer?.first_name ?? '-'} ${freelancer?.last_name ?? ''}`);
                }
                return '-';
            },
        }),
        columnHelper.accessor('allowed_statuten', {
            header: t('shifts_module.column_allowed_statuten'),
            enableSorting: false,
            cell: props => {
                const list = props.cell.getValue()?.length ? props.cell.getValue() : ['freelance'];
                const abbr = {freelance: 'F', interim: 'I', student: 'S', flexi_job: 'X'};
                return list.map(s => abbr[s] ?? s).join(' / ');
            },
        }),
        columnHelper.accessor('shift_applications_possibility', {
            header: t('general.fields.type'),
            enableSorting: false,
            cell: props => {
                const value = props.cell.getValue();
                return value === 'both' ? t('shifts.vpk_or_zk') : value === 'only_verpleegkundige' ? 'VPK' : 'ZK';
            },
        }),
        columnHelper.accessor('actions', {
            header: t('tables.actions'),
            enableSorting: false,
            cell: props => {
                const shift = props.row.original;
                return (
                    <div className={'flex flex-row space-x-4'}>
                        {shift.applications_count > 0 && !shift.freelancer?.id && (
                            <Link
                                to={`/customer/shifts/${shift.id}/applications`}
                                className={'flex bg-orange-500 w-7 h-7 rounded-full text-white flex-col justify-center border border-orange-500 hover:bg-transparent hover:border-orange-500 hover:text-orange-500 transition-all duration-300'}
                                title={t('shifts.view_applications')}
                            >
                                <FontAwesomeIcon icon={faArrowRight} className={'text-sm'} />
                            </Link>
                        )}
                        {!shift.has_contract && shift.applications_count === 0 && (
                            <button
                                onClick={() => {
                                    setShiftObjectToEdit(shift);
                                    setOpenEdit(true);
                                }}
                                className={'flex bg-gray-500 w-7 h-7 rounded-full text-white flex-col justify-center border border-gray-500 hover:bg-transparent hover:border-gray-500 hover:text-gray-500 transition-all duration-300'}
                                title={t('shifts.edit_shift')}
                            >
                                <FontAwesomeIcon icon={faArrowRight} className={'text-sm'} />
                            </button>
                        )}
                        {shift.freelancer?.id && (
                            <button
                                onClick={() => {
                                    setShiftObjectToEditTimes(shift);
                                    setOpenEditTimes(true);
                                }}
                                className={'flex bg-green-500 w-7 h-7 rounded-full text-white flex-col justify-center border border-green-500 hover:bg-transparent hover:border-green-500 hover:text-green-500 transition-all duration-300'}
                                title={t('shifts.change_times')}
                            >
                                <FontAwesomeIcon icon={faArrowRight} className={'text-sm'} />
                            </button>
                        )}
                    </div>
                )
            },
        })
    ];

    return (
        <div>
            <div>
                <div className={'flex flex-row justify-between mb-4'}>
                    <h1 className={'text-2xl font-semibold my-auto'}>{t('shifts.my_shifts')}</h1>
                    <div className={'flex flex-row justify-between gap-4'}>
                        <div className={'my-auto'}>
                            <button
                                onClick={() => {
                                    const newMode = viewMode === 'calendar' ? 'list' : 'calendar';
                                    setViewMode(newMode);
                                    setCurrentPage(0);
                                }}
                                className={`rounded-md border border-solid border-black cursor-pointer px-4 py-2 text-sm font-semibold shadow-sm transition-all duration-300 ease-in-out bg-black text-white hover:text-black hover:bg-transparent`}
                            >
                                <FontAwesomeIcon icon={viewMode === 'calendar' ? faList : faCalendar} className={'mr-2'} />
                                {viewMode === 'calendar' ? t('shifts.list_view') : t('shifts.calendar_view')}
                            </button>
                        </div>
                        <div className={'my-auto'}>
                            <button
                                onClick={() => setOpen(true)}
                                className={`rounded-md border border-solid border-black cursor-pointer px-4 py-2 text-sm font-semibold shadow-sm transition-all duration-300 ease-in-out bg-black text-white hover:text-black hover:bg-transparent`}
                            >
                                {t('shifts.add_shift')}
                            </button>
                        </div>
                    </div>
                </div>

                <BaseCard border={false} className={'mb-4'}>
                    <div className={'grid grid-cols-1 gap-4 md:grid-cols-4'}>
                        <div>
                            <SelectInput
                                name={'branch_id'}
                                options={branchesNotPaginated.map((branch) => {
                                    return {
                                        id: branch.id,
                                        value: branch.id,
                                        label: branch.company_name
                                    }
                                })}
                                setValue={setValue}
                                control={control}
                                value={getValues('branch_id') ?? null}
                                translationIndex={t('tables.branch')}
                                errors={errors}
                                clearable={true}
                            />
                        </div>
                        <div>
                            <SelectInput
                                name={'status'}
                                options={[
                                    { id: 'open_no_candidates', value: 'open_no_candidates', label: t('shifts.filter_open_no_candidates') },
                                    { id: 'open_with_candidates', value: 'open_with_candidates', label: t('shifts.filter_open_with_candidates') },
                                    { id: 'reserved', value: 'reserved', label: t('shifts.filter_reserved') },
                                    { id: 'confirmed', value: 'confirmed', label: t('general.status.confirmed') }
                                ]}
                                setValue={setValue}
                                control={control}
                                value={getValues('status') ?? null}
                                translationIndex={t('tables.status')}
                                errors={errors}
                                clearable={true}
                            />
                        </div>
                        {viewMode === 'list' && (
                            <>
                                <div>
                                    <DateTimePickerInput
                                        label={'Start datum'}
                                        name={'start_time'}
                                        register={register}
                                        setValue={setValue}
                                        control={control}
                                        dateFormat={'dd/MM/yyyy'}
                                        showTimeInput={false}
                                        isClearable={true}
                                        translationIndex={'general.fields.start_date'}
                                        errors={errors}
                                    />
                                </div>
                                <div>
                                    <DateTimePickerInput
                                        label={'Eind datum'}
                                        name={'end_time'}
                                        register={register}
                                        setValue={setValue}
                                        control={control}
                                        dateFormat={'dd/MM/yyyy'}
                                        showTimeInput={false}
                                        isClearable={true}
                                        translationIndex={'general.fields.end_date'}
                                        errors={errors}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </BaseCard>
            </div>

            {viewMode === 'calendar' ? (
                <div className={'grid grid-cols-1 xl:grid-cols-calendar p-4'}>
                    <div className={'hidden xl:block calendar-styled-ccp'}>
                        <DatePicker
                            onSelect={(e) => {
                                if (calendarRef.current?.getApi) {
                                    calendarRef.current.getApi()?.gotoDate(e)
                                }
                                setVisibleDate(dayjs(e))
                                setDate(dayjs(e))
                            }}
                            selected={dayjs(date).toDate() ?? new Date()}
                            onChange={() => {
                                console.log('changed')
                            }}
                            ref={datePickerRef}
                            onMonthChange={(date) => { setVisibleDate(dayjs(date)) }}
                            renderDayContents={(day, date) => {
                                const hasSomethingOnThisDay = shifts.find((shift) => {
                                    return dayjs(shift.start_time).format('DD-MM-YYYY') === dayjs(date).format('DD-MM-YYYY')
                                });

                                if (hasSomethingOnThisDay) {
                                    return (
                                        <div className="relative select-none">
                                            <span title={day} className="select-none">{day}</span>
                                            <div className="absolute bottom-0 left-1/2 select-none transform -translate-x-1/2 w-1 h-1 bg-secondary rounded-full"></div>
                                        </div>
                                    );
                                }

                                return <span title={day}>{day}</span>;
                            }}
                            inline={true}
                            peekNextMonth={true}
                            showMonthYearDropdown={false}
                            calendarStartDay={1}
                            locale={currentLang}
                        />
                    </div>

                    <div className={'xl:hidden mb-4'}>
                        <div className={"flex flex-row justify-between"}>
                            <div>
                                <button
                                    onClick={() => {
                                        if (calendarRef.current?.getApi) {
                                            calendarRef.current.getApi()?.prev()
                                            setDate(dayjs(calendarRef.current.getApi()?.getDate()))
                                        }
                                    }}
                                    className={`rounded-md border border-solid border-black cursor-pointer px-4 py-2 text-sm font-semibold shadow-sm transition-all duration-300 ease-in-out bg-black text-white hover:text-black hover:bg-transparent`}
                                >
                                    <FontAwesomeIcon icon={faChevronLeft} className={'m-auto'} />
                                </button>
                            </div>

                            <div className={'my-auto'}>
                                {
                                    calendarRef.current?.getApi && (
                                        <p>{calendarRef.current.getApi()?.view?.title}</p>
                                    )
                                }
                            </div>

                            <div>
                                <button
                                    onClick={() => {
                                        if (calendarRef.current?.getApi) {
                                            calendarRef.current.getApi()?.next()
                                            setDate(dayjs(calendarRef.current.getApi()?.getDate()))
                                        }
                                    }}
                                    className={`rounded-md border border-solid border-black cursor-pointer px-4 py-2 text-sm font-semibold shadow-sm transition-all duration-300 ease-in-out bg-black text-white hover:text-black hover:bg-transparent`}
                                >
                                    <FontAwesomeIcon icon={faChevronRight} className={'m-auto'} />
                                </button>
                            </div>
                        </div>
                    </div>

                    <BaseCard border={false}>
                        <div style={{ position: 'relative' }}>
                            {calendarLoading && (
                                <div className="absolute inset-0 z-50 flex items-center justify-center bg-white bg-opacity-70 pointer-events-none">
                                    <div className="loader">{t('shifts.loading_shifts')}</div>
                                </div>
                            )}
                            <FullCalendar
                                ref={calendarRef}
                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                initialView="timeGridDay"
                                initialDate={new Date()}
                                allDaySlot={false}
                                locales={[nlLocale, frLocale]}
                                locale={currentLang}
                                headerToolbar={false}
                                eventTimeFormat={{ hour: "2-digit", minute: "2-digit", hour12: false }}
                                slotLabelFormat={{ hour: "2-digit", minute: "2-digit", hour12: false }}
                                events={events}
                                firstDay={1}
                                dateClick={handleDateClick}
                                displayEventEnd={true}
                                eventContent={(arg) => {
                                    const { badges } = arg.event.extendedProps || {};
                                    const lines = (arg.event.title || '').split(/\r?\n/);
                                    return (
                                        <div className="fc-event-custom overflow-hidden text-xs leading-tight p-0.5">
                                            <div className="font-semibold">{arg.timeText}</div>
                                            {lines.map((line, i) => (
                                                <div key={i}>{line}</div>
                                            ))}
                                            {badges?.length > 0 && (
                                                <div className="flex gap-1 mt-1 flex-wrap">
                                                    {badges.map((b) => (
                                                        <span key={b} className="inline-block px-1.5 py-0.5 rounded text-[11px] font-bold text-gray-800" style={{backgroundColor: 'rgba(255,255,255,0.85)'}}>{b}</span>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    );
                                }}
                                eventClick={(info) => {
                                    if (info.event.backgroundColor === 'orange') {
                                        navigate(`/customer/shifts/${info.event.id}/applications`);
                                    }

                                    if (info.event.backgroundColor === 'grey') {
                                        setShiftObjectToEdit(shifts.find((shift) => shift.id === parseInt(info.event.id)))
                                        setOpenEdit(true)
                                    }

                                    if (info.event.backgroundColor === 'green') {
                                        setShiftObjectToEditTimes(shifts.find((shift) => shift.id === parseInt(info.event.id)))
                                        setOpenEditTimes(true)
                                    }
                                }}
                            />
                        </div>

                        <div className={'flex flex-wrap space-y-4 mt-4'}>
                            <div className={'flex flex-row w-full my-auto'}>
                                <div className={'w-6 h-6 bg-green-500 mr-4 rounded-full my-auto'}></div>
                                <p className={'my-auto'}>{t('shifts.candidacy_confirmed')}</p>
                            </div>

                            <div className={'flex flex-row w-full align-top'}>
                                <div className={'w-6 h-6 bg-yellow-500 mr-4 rounded-full'}></div>
                                <p className={'my-auto'}>{t('shifts.candidates_available_no_confirmation')}</p>
                            </div>

                            <div className={'flex flex-row'}>
                                <div className={'w-6 h-6 bg-gray-500 mr-4 rounded-full'}></div>
                                <p className={'my-auto'}>{t('shifts.open_no_candidacy')}</p>
                            </div>

                            <div className={'flex flex-row w-full'}>
                                <div className={'w-6 h-6 striped-red-grey border mr-4 rounded-full'}></div>
                                <p className={'my-auto'}>{t('shifts.not_published')}</p>
                            </div>

                            <div className={'flex flex-row w-full'}>
                                <div className={'w-6 h-6 bg-gray-300 mr-4 rounded-full'} style={{borderLeft: '8px solid #7c3aed'}}></div>
                                <p className={'my-auto'}>{t('shifts.multi_statuut')}</p>
                            </div>
                        </div>
                    </BaseCard>
                </div>
            ) : (
                <BaseCard>
                    {calendarLoading ? (
                        <div className="flex items-center justify-center py-8">
                            <div className="loader">{t('shifts.loading_shifts')}</div>
                        </div>
                    ) : shifts.length === 0 ? (
                        <div className="text-center text-gray-500 py-8">{t('shifts.no_results')}</div>
                    ) : (
                        <TanStackTable
                            columns={columns}
                            tableData={shifts}
                            laravelPaginationMetaData={shiftsPaginationMeta}
                            page={currentPage}
                            onChangePage={(newPage) => setCurrentPage(newPage)}
                        />
                    )}
                </BaseCard>
            )}

            <CreateShiftDialog
                open={open}
                onClose={() => setOpen(false)}
                onCreated={async () => {
                    if (viewMode === 'calendar') {
                        const monthStart = visibleDate.startOf('month').unix();
                        const monthEnd = visibleDate.endOf('month').unix();
                        await getMyShifts(null, null, monthStart, monthEnd, [], null, branchId, null, status)
                    } else {
                        const startTimeUnix = startTime ? dayjs(startTime).unix() : null;
                        const endTimeUnix = endTime ? dayjs(endTime).unix() : null;
                        await getMyShifts(null, null, startTimeUnix, endTimeUnix, [], null, branchId, currentPage + 1, status)
                    }
                }}
                customerId={user?.id}
                branches={branchesNotPaginated}
            />

            <UpdateShiftDialog open={openEdit} onClose={() => {
                setOpenEdit(false)
                if (viewMode === 'calendar') {
                    const monthStart = visibleDate.startOf('month').unix();
                    const monthEnd = visibleDate.endOf('month').unix();
                    getMyShifts(null, null, monthStart, monthEnd, [], null, branchId, null, status)
                } else {
                    const startTimeUnix = startTime ? dayjs(startTime).unix() : null;
                    const endTimeUnix = endTime ? dayjs(endTime).unix() : null;
                    getMyShifts(null, null, startTimeUnix, endTimeUnix, [], null, branchId, currentPage + 1, status)
                }
            }} customerId={user?.id} shift={shiftObjectToEdit} branches={branchesNotPaginated} />

            <ChangeDatesForShiftDialog open={openEditTimes} onClose={() => {
                setOpenEditTimes(false);
                if (viewMode === 'calendar') {
                    const monthStart = visibleDate.startOf('month').unix();
                    const monthEnd = visibleDate.endOf('month').unix();
                    getMyShifts(null, null, monthStart, monthEnd, [], null, branchId, null, status)
                } else {
                    const startTimeUnix = startTime ? dayjs(startTime).unix() : null;
                    const endTimeUnix = endTime ? dayjs(endTime).unix() : null;
                    getMyShifts(null, null, startTimeUnix, endTimeUnix, [], null, branchId, currentPage + 1, status)
                }
            }} customerId={user?.id} shift={shiftObjectToEditTimes} />
        </div>
    )
}
